import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-footer flex-right" }
const _hoisted_2 = ["disabled", "data-kt-indicator"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "on-submit": _ctx.formSubmit,
    "validation-schema": _ctx.validate,
    ref: "baseForm"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.submitting)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "reset",
              class: "btn btn-sm btn-light me-3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.formDiscard && _ctx.formDiscard(...args)))
            }, " Discard "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-sm btn-primary data-kt-indicator",
          disabled: _ctx.submitting,
          "data-kt-indicator": _ctx.submitting ? 'on':''
        }, _hoisted_5, 8, _hoisted_2)
      ])
    ]),
    _: 3
  }, 8, ["on-submit", "validation-schema"]))
}